
(function(){
  try {
    function skip(el){
      if(!el||el.dataset.grSafe)return true;
      el.dataset.grSafe='1';
      return false;
    }
    function fixATC(){
      try {
        var btns=document.querySelectorAll('.t4s-product-form__submit,[name="add"],.gr-sticky-atc__btn');
        btns.forEach(function(btn){
          if(skip(btn))return;
          btn.addEventListener('pointerdown',function(){
            try{
              requestAnimationFrame(function(){
                btn.style.opacity='0.75';
                requestAnimationFrame(function(){ btn.style.opacity=''; });
              });
            }catch(e){}
          });
        });
      }catch(e){}
    }
    function fixSwatches(){
      try {
        var swatches=document.querySelectorAll('.t4s-swatch__item,[data-swatch-item]');
        swatches.forEach(function(sw){
          if(skip(sw))return;
          sw.addEventListener('pointerdown',function(){
            try{
              requestAnimationFrame(function(){
                sw.style.outline='2px solid currentColor';
                setTimeout(function(){ sw.style.outline=''; },200);
              });
            }catch(e){}
          });
        });
      }catch(e){}
    }
    function prewarmCart(){
      try{
        var done=false;
        function warm(){
          if(done)return; done=true;
          fetch('/cart.js',{method:'GET'}).catch(function(){});
        }
        window.addEventListener('touchstart',warm,{once:true,passive:true});
        setTimeout(warm,3000);
      }catch(e){}
    }
    function contentVis(){
      try{
        if(!('CSS' in window)||!CSS.supports('content-visibility','auto'))return;
        document.querySelectorAll('.t4s-section').forEach(function(s,i){
          if(i<2)return;
          try{ s.style.contentVisibility='auto'; s.style.containIntrinsicSize='0 500px'; }catch(e){}
        });
      }catch(e){}
    }
    function imgDecode(){
      try{
        document.querySelectorAll('img:not([decoding])').forEach(function(img,i){
          try{
            img.setAttribute('decoding', i<3 ? 'sync' : 'async');
          }catch(e){}
        });
      }catch(e){}
    }
    function watchDOM(){
      try{
        if(!('MutationObserver' in window))return;
        var t;
        new MutationObserver(function(){
          clearTimeout(t);
          t=setTimeout(function(){ try{ fixATC(); fixSwatches(); }catch(e){} },400);
        }).observe(document.body,{childList:true,subtree:true});
      }catch(e){}
    }
    function init(){
      try{ fixATC(); fixSwatches(); imgDecode(); contentVis(); prewarmCart(); watchDOM(); }catch(e){}
    }
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',init);
    }else{ init(); }
  }catch(e){}
}());